<a class="iet_title_link" (click)="onClick($event)" style="cursor: pointer;">
    {{params.value}}
</a>